import { useEffect, useState } from 'react';
import { findQuestionnaireByVariant } from '../util/questionnaire';
import {
  setNoAppointmentMode,
  setQuestionnaireConfig,
} from '../reducers/graph';
import { useDispatch, useSelector } from 'react-redux';
import { QuestionnaireConfig, RootState } from '@/types/graph';
import { selectQueryVariant } from '@/selectors/version';

export const useQuestionnaireVariant = () => {
  const [variant, setVariant] = useState<string>();
  const searchParams = useSelector((state: RootState) => state.searchParams);
  const queryVariant = useSelector(selectQueryVariant);
  const graphVariant = useSelector((state: RootState) => state.graph.variant);
  const questionnaireConfig = useSelector(
    (state: RootState) => state.questionnaire.config,
  );
  const previousQueryVariant = useSelector(
    (state: RootState) => state.previousQueryVariant,
  );
  const professionalVariant = useSelector(
    (state: RootState) =>
      state.consultation.professional?.defaultQuestionnaireVariant ?? undefined,
  );
  const consultationVariant = useSelector(
    (state: RootState) => state.consultation.variant,
  );
  const isInvitation = useSelector(
    (state: RootState) => state.graph.mode === 'INVITATION',
  );
  const dispatch = useDispatch();

  useEffect(() => {
    // An invitation runs its consultation's variant, which the server owns:
    // a `?variant=` or a variant left over from an earlier visit on this
    // device must not override it (ALDO-2759).
    setVariant(
      (isInvitation ? consultationVariant : undefined) ??
        queryVariant ??
        consultationVariant ??
        previousQueryVariant ??
        professionalVariant ??
        'DEFAULT',
    );
  }, [
    setVariant,
    isInvitation,
    queryVariant,
    consultationVariant,
    previousQueryVariant,
    professionalVariant,
  ]);

  useEffect(() => {
    if (variant && (variant !== graphVariant || !questionnaireConfig)) {
      const config = findQuestionnaireByVariant(variant);
      if (config) {
        dispatch(setQuestionnaireConfig(config as QuestionnaireConfig));
      }
    }
  }, [
    dispatch,
    setQuestionnaireConfig,
    variant,
    graphVariant,
    questionnaireConfig,
  ]);

  useEffect(() => {
    if ('no_appointment' in searchParams) {
      dispatch(setNoAppointmentMode(true));
    }
  }, [dispatch, searchParams, questionnaireConfig]);
};
